namespace GeniuzPOS.QRreport {
    export enum ConsignFg {
        ItemTypeFg1 = 0,
        ItemTypeFg2 = 1
    }
    Serenity.Decorators.registerEnumType(ConsignFg, 'GeniuzPOS.QRreport.ConsignFg');
}
